import { Fragment } from "react";
import { useTranslation } from "react-i18next";

import Dropdown from "./Dropdown";

const ChannelBar = ({ content }) => {
  const { t } = useTranslation();
  let result;
  if (content === "about") {
    result = "Details";
  } else if (content === "education") {
    result = t("online_certifications");
  } else if (content === "skills") {
    result = t("personal_skills");
  }

  return (
    <div className="channel-bar shadow-lg">
      <div className="channel-block">
        <h5 className="channel-block-text">{result}</h5>
      </div>
      <div className="channel-container">
        {result === "Details" && (
          <Fragment>
            <Dropdown header={t("address")} selections={t("my_address", { returnObjects: true })} />
            <Dropdown header={t("phone")} selections={t("my_phone", { returnObjects: true })} />
            <Dropdown header={t("e_mail")} selections={t("my_e_mail", { returnObjects: true })} />
            <Dropdown header={t("nationality")} selections={t("my_nationality", { returnObjects: true })} />
            <Dropdown header={t("date_of_birth")} selections={t("my_birth", { returnObjects: true })} />
          </Fragment>
        )}

        {result === t("online_certifications") && <Dropdown header={t("online_certifications")} selections={t("my_certifications", { returnObjects: true })} />}

        {result === t("personal_skills") && (
          <Fragment>
            <Dropdown header={t("languages")} selections={t("my_languages", { returnObjects: true })} />
            <Dropdown header={t("soft_skills")} selections={t("my_soft_skills", { returnObjects: true })} />
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default ChannelBar;
